// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { Row, Col } from 'antd/lib/grid';

import ModelRunnerModal from 'components/model-runner-modal/model-runner-dialog-ref';
import MoveReferenceModal from 'components/move-reference-modal/move-reference-modal';
import ReferenceItem from 'containers/references-page/reference-item';

import dimensions from '../projects-page/dimensions';

export interface Props {
    currentReferencesIndexes: number[];
}

function ReferenceListComponent(props: Props): JSX.Element {
    const { currentReferencesIndexes } = props;
    const referenceViews = currentReferencesIndexes.map((tid, id): JSX.Element => <ReferenceItem idx={id} referenceID={tid} key={tid} />);

    return (
        <>
            <Row justify='center' align='middle'>
                <Col className='cvat-references-list' {...dimensions}>
                    {referenceViews}
                </Col>
            </Row>
            <ModelRunnerModal />
            <MoveReferenceModal />
        </>
    );
}

export default React.memo(ReferenceListComponent, (prev: Props, cur: Props) => (
    prev.currentReferencesIndexes.length !== cur.currentReferencesIndexes.length || prev.currentReferencesIndexes
        .some((val: number, idx: number) => val !== cur.currentReferencesIndexes[idx])
));
